import { toast } from "react-toastify";

import { PlatformMemberChangeResult } from "./platformTypes";

/**
 * Reports what a membership change did to the seat count. Shared so both the
 * team page and the subscription page word it identically — the delta is the
 * point of the confirmation, because promoting the first editor on a team is a
 * +2 move rather than +1 (the owner starts consuming a seat at the same time).
 */
export function reportSeatChange(
  result: PlatformMemberChangeResult,
  licenses?: number,
): void {
  const change =
    result.seatCountAfter === result.seatCountBefore
      ? "no seat change"
      : `seats ${result.seatCountBefore} → ${result.seatCountAfter}`;

  if (licenses !== undefined && result.seatCountAfter > licenses) {
    toast.warning(`${change} — now over the ${licenses} licenses purchased`);
    return;
  }
  toast.success(change);
}
